module.exports = __webpack_public_path__ + "static/media/accuscience.89314a5c.png";